import "./FooterStyles.css"

const Footer = () => {
    return(
        <div className="footer">
            <div className="top">
                <div>
                    <h1>Multishades Insurance</h1>
                    <p>Someone's sitting in the shade today because someone planted a tree a long time ago<br></br><em>-Warren Buffett</em></p>
                    </div>
                        
                    <div>
                        <a href="/">
                            <i className="fa-brands fa-facebook-square"></i>
                        </a>
                        <a href="/">
                            <i className="fa-brands fa-instagram-square"></i>
                         </a>
                        <a href="/">
                            <i className="fa-brands fa-behance-square"></i>
                        </a>
                        <a href="/">
                            <i className="fa-brands fa-twitter-square"></i>
                        </a>
                    </div>
                </div>
            <div/>

            <div className="bottom">
                <div>
                    <h4>Navigation</h4>
                    <a href="/">Home</a>
                    <a href="/service">Services</a>
                    <a href="/contact">Contact us</a>
                    <a href="/about">About Us</a>
                </div>
                <div>
                    <h4>Contacts</h4>
                    <a href="/">TRV Towers 8th floor <br></br>
                    Lower MuseumHill Nairobi</a>
                    <a href="/">info@multishadeinsurance.com</a>
                    <a href="/">+254 727 972 901</a>
                       
                </div>
                <div>
                    <h4>Help</h4>
                    <a href="/">Support</a>
                    <a href="/">Troublshooting</a>
                    <a href="/">Contact us</a>
                        
                </div>
                <div>
                    <h4>Policies</h4>
                    <a href="/">Terms and Conditions</a>
                    <a href="/">Status</a>
                    <a href="/">License</a>
                    <a href="/">Policy  Licences</a>
                </div>
                </div>
         
        </div>
    )
    
}

export default Footer; 